import { render, staticRenderFns } from "./MirrorDetailsNote.vue?vue&type=template&id=f3432fca&scoped=true&"
import script from "./MirrorDetailsNote.vue?vue&type=script&lang=js&"
export * from "./MirrorDetailsNote.vue?vue&type=script&lang=js&"
import style0 from "./MirrorDetailsNote.vue?vue&type=style&index=0&id=f3432fca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3432fca",
  null
  
)

export default component.exports